<template>
    <a-modal
        centered
        :visible="visible"
        :title="mode==='create'?'新增部门':'修改部分'"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="360"
    >
        <a-form-model :model="form" ref="department-create" :rules="rules">
            <a-form-model-item label="名称" prop="name">
                <a-input v-model="form.name" />
            </a-form-model-item>
            <a-form-model-item label="备注">
                <a-textarea v-model="form.remark" />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
export default {
    props: {
        visible: {
            default: false
        },
        record: null,
        mode: {
            default: "create"
        }
    },
    data() {
        return {
            submitting: false,
            form: { name: null, remark: null },
            rules: {
                name: [
                    {
                        required: true,
                        trigger:['change', 'blur'],
                        message: "请输入名称"
                    }
                ]
            }
        };
    },
    watch: {
        visible(v) {
            if (v) {
                this.form = this.record;
            } else {
                this.form = { name: null, description: null };
            }
        }
    },
    methods: {
        cancel() {
            this.$emit("close");
        },
        on_submit() {
            this.$refs["department-create"].validate(valid => {
                if (valid) {
                    if (this.mode === "create") {
                        return this.on_create();
                    } else {
                        return this.on_edit();
                    }
                } else {
                    this.$message.error("请检查并填写完需要录入的内容");
                    return false;
                }
            });
        },
        on_create() {
            this.submitting = true;
            this.$http
                .post("/auth/group/", this.form)
                .then(res => {
                    if (res.success) {
                        this.cancel();
                        this.$emit("load");
                    }
                })
                .catch()
                .then(() => {
                    this.submitting = false;
                });
        },
        on_edit() {
            this.submitting = true;
            this.$http
                .put("/auth/group/" + this.form.id, this.form)
                .then(res => {
                    if (res.success) {
                        this.cancel();
                        this.$emit("load");
                    }
                })
                .catch()
                .then(() => {
                    this.submitting = false;
                });
        },
        after_close() {
            this.$refs["department-create"].resetFields();

            this.form = {
                name: null,
                remark: null
            };
        }
    }
};
</script>
